export const getRoundNameToTranslate = ( roundName = '' ) => {
  const nameArray = roundName.split( ' ' );
  return { name: nameArray[0], number: nameArray[1] };
};
